module.exports = __webpack_public_path__ + "img/home2.693e1065.png";